export default __webpack_public_path__ + "static/media/service-req.8b6fa563.svg";